var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.610945 0.176228C0.665786 0.120366 0.730934 0.0760455 0.802659 0.0458054C0.874384 0.0155653 0.951276 0 1.02893 0C1.10659 0 1.18348 0.0155653 1.2552 0.0458054C1.32693 0.0760455 1.39208 0.120366 1.44692 0.176228L8.11344 6.95092L14.78 0.176228C14.8348 0.120456 14.9 0.0762158 14.9717 0.0460325C15.0434 0.0158492 15.1203 0.000314061 15.1979 0.000314061C15.2756 0.000314061 15.3524 0.0158492 15.4242 0.0460325C15.4959 0.0762158 15.561 0.120456 15.6159 0.176228C15.6708 0.231999 15.7144 0.298209 15.7441 0.371078C15.7738 0.443947 15.7891 0.522048 15.7891 0.600921C15.7891 0.679793 15.7738 0.757894 15.7441 0.830763C15.7144 0.903632 15.6708 0.969842 15.6159 1.02561L8.53142 8.2238C8.47658 8.27966 8.41143 8.32398 8.33971 8.35422C8.26798 8.38446 8.19109 8.40002 8.11344 8.40002C8.03578 8.40002 7.95889 8.38446 7.88717 8.35422C7.81544 8.32398 7.75029 8.27966 7.69545 8.2238L0.610945 1.02561C0.555965 0.969893 0.512345 0.903699 0.482583 0.830823C0.45282 0.757947 0.4375 0.679821 0.4375 0.600921C0.4375 0.52202 0.45282 0.443894 0.482583 0.371018C0.512345 0.298142 0.555965 0.231948 0.610945 0.176228V0.176228Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorDown);
export default __webpack_public_path__ + "static/media/vectorDown.7a6f3198077c14606c8f0c1998cc6fd5.svg";
export { ForwardRef as ReactComponent };